// Presentation only: the strategy's label ships on the version (`strategy_label`).
export const STRATEGY_COLORS: Record<string, string> = {
  top_performer: '#2C9C6D',
  top_spender: '#155DFC',
  new_concept: '#831DFB',
};
